import { getAncestorTypes } from './get-ancestor-types.js';
import { RgTraverse } from './rg-traverse.js';

/** Recursively get all RgObjects of `type` */
function getRgObjectsOfType(obj, type) {
    const list = [];
    const types = type instanceof Array ? type : [type];
    const ancestors = types.flatMap(t => getAncestorTypes(t));
    obj = Array.isArray(obj) ? obj : [obj];
    for (const item of obj) {
        RgTraverse(item, o => {
            // if child found
            if (types.includes(o.type)) {
                list.push(o);
                return false;
            }
            // stop if it couldn't be an ancestor
            if (!ancestors?.includes(o.type))
                return false;
        });
    }
    return list;
}

export { getRgObjectsOfType };
//# sourceMappingURL=get-rg-objects-of-type.js.map
